import {
  HttpInterceptorFn,
  HttpHandlerFn,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError, throwError } from 'rxjs';

/**
 * Interceptor para las peticiones a NetPay
 * Se encarga de añadir headers específicos y manejar errores
 */
export const netpayInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  // Verificar si la petición es para NetPay
  if (req.url.includes(environment.netpay.apiUrl)) {
    // No modificamos las peticiones que ya tienen authorization
    // (como la de obtener token que usa Basic auth)
    if (!req.headers.has('Authorization')) {
      // Aquí podríamos añadir headers específicos para NetPay si fuera necesario
      const netpayReq = req.clone({
        headers: req.headers.set('Content-Type', 'application/json'),
      });

      return next(netpayReq).pipe(
        catchError((error: HttpErrorResponse) => {
          // Manejar errores específicos de NetPay
          console.error('Error en petición a NetPay:', error);

          let errorMsg = 'Error de comunicación con el servicio de pagos';

          if (error.error && typeof error.error === 'object') {
            errorMsg = error.error.message || errorMsg;
          }

          // Registrar el error (en producción podría enviar a un servicio de registro de errores)
          console.error(`NetPay API Error (${error.status}):`, errorMsg);

          return throwError(() => new Error(errorMsg));
        })
      );
    }
  }

  // Para otras peticiones, continuar sin modificar
  return next(req);
};
